import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import ScrollToTopOnMount from '../../helpers/ScrollToTopOnMount/ScrollToTopOnMount';
import { publicRequest } from '../../services/ApiService';
import AuthSection from '../../components/Auth/AuthSection';

class AuthPage extends Component {
  state = {
    offersCount: null,
    geoCount: null,
    exclusivesCount: null,
  };

  componentDidMount() {
    publicRequest.getTotalInfo().then((response) => {
      const { items } = response;
      if (items && items.offers) {
        this.setState(() => ({
          offersCount: items.offers,
          geoCount: items.geo,
          exclusivesCount: items.exclusives,
        }));
      }
    });

    // const pathname = window.location.pathname.replace(/\/$/, '');
    // if (pathname === '/publisher/sign_up') {
    //   this.props.openModal({}, 'affiliateSignUp');
    // } else if (pathname === '/publisher/sign_in') {
    //   this.props.openModal({}, 'affiliateSignIn');
    // } else if (pathname === '/recovery') {
    //   this.props.openModal({}, 'affiliatePasswordRecovery');
    // }
  }

  getOffersBlockTitle = (offersCount) => (
    <FormattedMessage
      id="offers_block.homepage.title"
      defaultMessage="Work with {offersCount, plural, one {# offer} other {$ offers} }  in different verticals"
      values={{
        offersCount,
      }}
    />
  );

  render() {
    const { offersCount, geoCount, exclusivesCount } = this.state;
    const {
      match: {
        params: { type },
      },
    } = this.props;

    return (
      <>
        <ScrollToTopOnMount />
        <AuthSection
          type={type}
          offersCount={offersCount}
          geoCount={geoCount}
          exclusivesCount={exclusivesCount}
        />
      </>
    );
  }
}

export default AuthPage;
